import React from 'react';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import SideNavBar from '../SideNavBar/SideNavBar';
import { useParams } from 'react-router-dom';
import { deleteOffboadingTemplateTaskData, getOffboadingTemplateTaskData } from '../../service/adminApi';
import Popup from '../ConformationPopup/Popup';

function OffboardingTask() {
    const params = useParams();
    const [templateId, setTemplateId] = React.useState(params.tid);
    const [offboardingTemplateTaskList, setOffboardingTemplateTaskList] = React.useState([]);
    const [editOffboardingTaskData, setEditOffboardingTaskData] = React.useState();
    const [flag, setFlag] = React.useState(false);
    const [editId, setEditId] = React.useState('');
    const [deleteIndex, setDeleteIndex] = React.useState();
    const [hideContainer, setHideContainer] = React.useState(true);

    let breadCrumbs = [
        { title: 'Dashboard', isActive: true, path: '/Overview' },
        { title: 'Admin', isActive: true, path: '/admin/accountbranding' },
        { title: 'Offboarding', isActive: false, path: '' },
    ];

    React.useEffect(() => {
        if (params.tid !== undefined) {
            setTemplateId(params.tid);
        }
    }, [params.tid]);

    React.useEffect(() => {
        getTemplateTask();
    }, []);

    const getTemplateTask = async () => {
        let data = {
            template_id: templateId,
        };
        const response = await getOffboadingTemplateTaskData(data);
        if (response.data.statusCode === 200) {
            setOffboardingTemplateTaskList(response.data.data);
        }
    };

    const removeTaskData = async () => {
        let data = {
            id: offboardingTemplateTaskList[deleteIndex].id,
            is_active: false,
        };
        const response = await deleteOffboadingTemplateTaskData(data);
        if (response.data.statusCode === 200) {
            let array = offboardingTemplateTaskList;
            let arr = array.splice(deleteIndex, 1);
            let updatedData = array;
            setOffboardingTemplateTaskList(updatedData);
            setFlag(!flag);
        }
    };

    const updateOffbordingDetails = (data) => {

        switch (data) {
            case 'cancel':
                setEditOffboardingTaskData({});
                break;
            case 'update':
                getTemplateTask();
                setEditId('');
                break;
            default:
                break;
        }
    };

    const renderTemplateTaskList = () => {
        if (offboardingTemplateTaskList.length > 0) {
            return (
                <div className="row">
                    <ul className="list-unstyled my-2 ">
                        {offboardingTemplateTaskList.map((task, index) => {
                            return (
                                <li className="bg-white hive-table-sort px-4 mt-2 py-3">
                                    <ul className="list-unstyled d-flex justify-content-between align-items-center">
                                        <li className="d-flex align-items-center policy-text-width">
                                            <div>
                                                {task.task_id == 2 ? (
                                                    <img src="/Images/offboardingCheckbox.svg" alt="icon" className="" />
                                                ) : (
                                                    <img src="/Images/offboardingUpload.svg" alt="icon" className="" />
                                                )}
                                            </div>
                                            <div className="ps-5">
                                                <h6 className="tt-bold font-15 policy-darkbluefont pt-2">{task.task_name}</h6>
                                            </div>
                                        </li>

                                        <li className="me-4 align-self-center">
                                            <a
                                                onClick={() => {
                                                    setEditOffboardingTaskData(task);
                                                    setEditId(task.id);
                                                    setHideContainer(false);
                                                }}
                                                className=" ms-2"
                                                alt=""
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#offcanvasRight"
                                                aria-controls="offcanvasRight"
                                            >
                                                <img src="/Images/edit1.svg" className="ms-5" alt="bin" />
                                            </a>
                                            <a
                                                onClick={() => {
                                                    setDeleteIndex(index);
                                                }}
                                                data-bs-toggle="modal"
                                                data-bs-target="#logout"
                                                className=""
                                                alt=""
                                            >
                                                <img src="/Images/bin.svg" className="ms-4" alt="close" />
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        } else {
            return (
                <div className="row justify-content-center  w-100">
                    <img src="/Images/nodatafound.png" alt="no-records" style={{ width: 700, height: 500 }} />
                    <span className="row justify-content-center tt-bold font-16">No offboarding Task</span>
                </div>
            );
        }
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbs} />
            {hideContainer == false ? (
                <SideNavBar
                    form="templateTask"
                    editData={editOffboardingTaskData}
                    handleData={(data) => {
                        updateOffbordingDetails(data);
                    }}
                    templateId={templateId}
                    hideContainer={hideContainer}
                    setHideContainer={() => setHideContainer()}
                />
            ) : null}
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                        <h5 className="bold-text tt-bold font-18">Offboarding</h5>
                        <a
                            className="btn hive-btn-primary"
                            type="button"
                            // data-bs-toggle="offcanvas"
                            // data-bs-target="#offcanvasRight"
                            // aria-controls="offcanvasRight"
                            onClick={() => setHideContainer(false)}
                        >
                            <img className="me-2" src="/Images/plus.svg" />
                            New Task
                        </a>
                    </div>
                </div>
            </div>
            {renderTemplateTaskList()}
            <Popup
                deleteData={() => {
                    removeTaskData();
                }}
            />
        </div>
    );
}

export default OffboardingTask;
